import * as React from "react";
import Btn from "@warda/library-ui/core/Btn";
import { ACT_VPORT } from "../reducer";
import { ViewMode } from "../constants";
import { useContextDispatchViewport } from "../SharePage";
const BtnSearch = ({ className, style, viewMode }) => {
    const dispatchViewport = useContextDispatchViewport();
    const cbOnClick = React.useCallback(() => {
        dispatchViewport({ type: ACT_VPORT.VIEW_MODE_SEARCH });
    }, [dispatchViewport]);
    if (viewMode === ViewMode.SEARCH)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Btn, { className: className, style: style, icon: "search", onClick: cbOnClick })));
};
export default BtnSearch;
